module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6x0lw"))).then(() => parcelRequire('54bLn'));